<template>
  <aside id="sidebar" class="off-canvas-sidebar">
    <a
      v-on:click="closeSidebar"
      class="brand"
      href="/"
      role="banner"
      aria-labelledby="app-title"
    >
      <img src="@/assets/logo.svg" height="28" width="28" alt="Logo" />
      <span id="app-title" class="h5 mx-2 text-dark">MATPOWER</span>
    </a>
    <nav>
      <ul class="menu" role="menu">
        <li v-on:click="closeSidebar" class="menu-item my-2" role="none">
          <router-link to="/" role="menuitem">
            <span>Case</span>
          </router-link>
        </li>
        <li v-on:click="closeSidebar" class="menu-item py-1" role="none">
          <router-link to="/bus" role="menuitem">
            <span>Buses</span>
            <div class="menu-badge">
              <label class="label label-primary c-hand" v-if="buses">
                {{ buses }}
              </label>
            </div>
          </router-link>
        </li>
        <li v-on:click="closeSidebar" class="menu-item pt-1" role="none">
          <router-link to="/gen" role="menuitem">
            <span>Generators</span>
            <div class="menu-badge">
              <label class="label label-primary c-hand" v-if="gens">
                {{ gens }}
              </label>
            </div>
          </router-link>
        </li>
        <li v-on:click="closeSidebar" class="menu-item py-1" role="none">
          <router-link to="/branch" role="menuitem">
            <span>Branches</span>
            <div class="menu-badge">
              <label class="label label-primary c-hand" v-if="branches">
                {{ branches }}
              </label>
            </div>
          </router-link>
        </li>
        <li v-on:click="closeSidebar" class="menu-item py-1" role="none">
          <router-link to="/dcline" role="menuitem">
            <span>DC Lines</span>
            <div class="menu-badge">
              <label class="label label-primary c-hand" v-if="dclines">
                {{ dclines }}
              </label>
            </div>
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import MPCStore from "../stores/MPCStore";

export default {
  name: "Sidebar",
  computed: {
    buses() {
      return MPCStore.methods.getBuses().length;
    },
    gens() {
      return MPCStore.methods.getGens().length;
    },
    branches() {
      return MPCStore.methods.getBranches().length;
    },
    dclines() {
      return MPCStore.methods.getDCLines().length;
    }
  },
  methods: {
    openSidebar() {
      document.getElementById("sidebar").classList.add("active");
    },
    closeSidebar() {
      document.getElementById("sidebar").classList.remove("active");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.off-canvas .off-canvas-sidebar {
  min-height: 100vh;
  border-right: 0.05rem solid $border-color-dark;
}

.off-canvas-sidebar .menu {
  background-color: $gray-color-light;
  box-shadow: none;
}

.off-canvas-sidebar > nav > ul > li > a > span {
  font-weight: 600;
}

.off-canvas-sidebar > nav > ul > ul {
  padding-right: 0;
}

a.brand {
  margin: 0.8rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  text-decoration: none;
}
</style>
